var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"name"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"name-input",domProps:{"value":(_vm.name)},on:{"change":function($event){return _vm.$emit('changeName', _vm.name)},"input":function($event){if($event.target.composing)return;_vm.name=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }